<script>
export default {
    name: "dialog-base",
    props: {
        maxWidth: {
            type: Number,
            default: 1024
        },
        showDialog: Boolean,
        persistent: Boolean,
        fullscreen: Boolean
    }
}
</script>

<template>
    <v-dialog
        :fullscreen="fullscreen"
        :persistent="persistent"
        :max-width="maxWidth"
        :value="showDialog"
        @input="$emit('close')"
    >
        <v-card>
            <slot/>
        </v-card>
    </v-dialog>
</template>
